
<div>

  @if (!isObserver) {
    <fieldset style="margin-bottom: 30px;">
      <legend style="font-size: 20px; font-weight: bold;">My Networks</legend>
      <div style="display: grid; grid-template-columns: 1fr 4fr;">
        @if (hasNetworks) {
          <div class="my-networks-nav">
            @for (network of networks; track network) {
              <div class="network-name" [class.active]="network == selectedNetwork">
                <i class="fa fa-arrow-right" style="margin-right: 5px;"></i>
                <span (click)="selectNetwork(network)">{{network.Name}}</span>
              </div>
            }
          </div>
        }
        @if (!hasNetworks) {
          <div style="font-family: 'Roboto', 'Trebuchet MS', Arial, Helvetica, sans-serif; font-size: large; margin: 20px 0px 30px 15px;">
            None
          </div>
        }
        @if (hasNetworks && hasSelectedNetwork) {
          <div>
            <share-source [sharedItemGuid]="selectedNetworkGuid"></share-source>
          </div>
        }
        @if (hasNetworks && !hasSelectedNetwork) {
          <div style="font-family: 'Roboto', 'Trebuchet MS', Arial, Helvetica, sans-serif; font-size: large; margin-top: 30px;">
            Select a network to see who it has been shared with
          </div>
        }
      </div>
    </fieldset>
  }

  <fieldset>

    <legend style="font-size: 20px; font-weight: bold;">Networks Shared With Me</legend>

    @if (hasSharedNetworks) {
      <div style="margin-top: 10px; margin-bottom: 20px;">
        <share-target></share-target>
      </div>
    }

    @if (!hasSharedNetworks) {
      <div style="font-family: 'Roboto', 'Trebuchet MS', Arial, Helvetica, sans-serif; font-size: large; margin: 20px 0px 30px 15px;">
        None
      </div>
    }

  </fieldset>

</div>